import { EPNodeFieldsResolvers } from '../5-node/fields';
export const epQPFieldsResolvers = {
    EPQP: EPNodeFieldsResolvers,
};
